<template>
  <bizgain-component-layout
    :is-content-top="true"
    :is-next-btn-enabled="true"
    :col-width="{
      'mx-5 px-4': !$vuetify.breakpoint.xsOnly,
      'mx-2': $vuetify.breakpoint.xsOnly
    }"
    view-port-height="170px"
  >
    <template v-slot:heading>
      {{ $t('message.bizgainOnboarding.businessTypeServiceHeading') }}
    </template>
    <template v-slot:content>
      <v-flex xs12 class="business-type-services">
        <div class="elevation-3 rounded pa-2 mb-3">
          <v-flex xs12>
            <div class="px-0">
              <div class="label">
                {{ $tc('message.bizgainOnboarding.businessType') }}
              </div>
              <v-layout>
                <v-flex xs12 lg12 md4>
                  <v-autocomplete
                    ref="businessType"
                    :solo="businessType && !isMenuActive"
                    flat
                    v-model="businessType"
                    :search-input.sync="search"
                    :items="searchResults"
                    :placeholder="
                      $tc('message.bizgainOnboarding.SearchBusinessType')
                    "
                    return-object
                    :loading="loadingBusinessCategories"
                    :menu-props="{ maxHeight: 200 }"
                    :no-filter="true"
                    :no-data-text="$t('message.bizgainOnboarding.noDataFound')"
                    :hide-no-data="!showNoDataMessage"
                    @input="getSelectedServices"
                    class="pt-0 mt-0 business-type-input"
                    :class="{
                      'business-type-selected': businessType && !isMenuActive
                    }"
                    :append-icon="businessType && !isMenuActive ? 'edit' : ''"
                  />
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
          <v-flex
            xs12
            v-if="suggestedCategories && suggestedCategories.length > 0"
            class="suggestions business-type-suggestion"
          >
            <v-layout row wrap>
              <v-flex
                lg12
                xs12
                ma-0
                pa-0
                class="small-label"
              >
                {{ $tc('message.bizgainOnboarding.suggestions') }}
              </v-flex>
              <div
                v-for="(suggestedCategory, index) in suggestedCategories"
                :key="index"
              >
                <v-chip
                  class="mx-1 suggestion"
                  :class="{
                    'selected-suggestion':
                      businessType.value &&
                      businessType.value.id == suggestedCategory.id
                  }"
                  @click="updateBusinessType(suggestedCategory)"
                >
                  <span>
                    {{ suggestedCategory && suggestedCategory.displayName }}
                  </span>
                </v-chip>
              </div>
            </v-layout>
          </v-flex>
        </div>

        <v-flex xs12 class="services elevation-3 rounded px-2 py-2 mb-2">
          <div>
            <div class="label">
              {{ $tc('message.bizgainOnboarding.Services') }}
            </div>
            <business-services
              @services-update="updateNewServices"
              ref="businessService"
              :existing-business-service="false"
            />
          </div>
        </v-flex>

        <v-flex v-if="serviceSuggestion.length > 0" class="service-suggestions">
          <v-layout row wrap>
            <v-flex class="py-2 small-label" xs12>
              {{ $tc('message.bizgainOnboarding.suggestions') }}
            </v-flex>
            <v-flex
              shrink
              ma-0
              pa-0
              v-for="(suggestion, index) in serviceSuggestion"
              :key="index"
              @click="selectServiceFromSuggestion(suggestion, index)"
            >
              <v-chip
                class="suggestion"
                :class="{
                  'selected-suggestion': newServices.indexOf(suggestion) > -1
                }"
              >
                <span>
                  {{ suggestion }}
                </span>
              </v-chip>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </template>
    <template v-slot:btn-content>
      <v-flex xs12>
        <v-layout :class="{ 'column reverse': $vuetify.breakpoint.xsOnly }">
          <v-flex
            :class="{
              'xs2 nxt-btn-margin mt-0': !$vuetify.breakpoint.xsOnly,
              xs12: $vuetify.breakpoint.xsOnly
            }"
          >
            <v-btn
              depressed
              class="mx-0 w-100 next-btn-color primary-btn-xs"
              :disabled="
                newServices.length <= 0 ||
                  loadingBusinessCategories ||
                  !businessType
              "
              @click="updateBusinessDetails"
              :loading="isBusinessCategoriesUpdate"
            >
              {{ $t('message.bizgainOnboarding.next') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </template>
  </bizgain-component-layout>
</template>
<script>
import {
  VLayout,
  VFlex,
  VAutocomplete,
  VChip,
  VBtn
} from 'vuetify/lib';
import { mapActions, mapGetters } from 'vuex';
import debounce from 'lodash/debounce';
import { ApiService } from 'Features/bizgainOnboarding/services/apiService';
import {
  bizgainOnboardingRoutes,
  launchState,
  onboardingSections
} from 'Features/bizgainOnboarding/constants';
import BizgainComponentLayout from 'Components/BizgainComponentLayout/BizgainComponentLayout.vue';
import { Chat } from 'Mixins/chat';
const { getBusinessCategories } = new ApiService();
import onboardingRedirect  from 'Mixins/onboardingRedirect';
import BusinessServices from '../../../../../components/BusinessServices/BusinessServices.vue';

export default {
  mixins: [Chat, onboardingRedirect],
  components: {
    VLayout,
    VFlex,
    VAutocomplete,
    VChip,
    VBtn,
    BizgainComponentLayout,
    BusinessServices
  },
  data() {
    return {
      businessType: null,
      search: null,
      searchResults: [],
      isAddService: false,
      newServices: [],
      serviceSuggestion: [],
      newBusinessDetails: null,
      loadingBusinessCategories: false,
      bizgainOnboardingRoutes,
      isBusinessCategoriesUpdate: false,
      isMenuActive: false,
      enableNoDataText: false
    };
  },
  computed: {
    ...mapGetters([
      'suggestedCategories',
      'category',
      'services',
      'suggestedServices',
      'businessDetails',
      'isError'
    ]),
    showNoDataMessage() {
      return this.enableNoDataText && !this.loadingBusinessCategories;
    }
  },
  async created() {
    if (this.category) {
      let businessCategory = {
        text: this.category.displayName,
        value: this.category
      };
      this.searchResults.push(businessCategory);
      this.businessType = businessCategory;
    } else {
      this.search = '';
    }
    this.addServiceSuggestions(this.suggestedServices);
    this.setCurrentSection(onboardingSections.BUSINESSDETAILS);
    this.setCurrentRoute(bizgainOnboardingRoutes.BusinessTypeServices.name);
  },
  mounted() {
    // v-autocomplete does not have event for blur and focus
    let businessTypeInput = this.$refs.businessType.$refs.input;
    businessTypeInput.onfocus = this.onFocus;
    businessTypeInput.onblur = this.onBlur;
  },
  methods: {
    ...mapActions([
      'setCurrentSection',
      'setCurrentRoute',
      'patchBusinessDetails',
      'updateMessage',
      'clearMessages'
    ]),
    onFocus() {
      this.isMenuActive = true;
    },
    onBlur() {
      this.isMenuActive = false;
    },
    getCategories: debounce(async function(keyword) {
      try {
        this.searchResults = [];
        this.loadingBusinessCategories = true;
        this.enableNoDataText = true;
        this.clearMessages();
        let businessCategories = await getBusinessCategories(keyword);
        if (
          businessCategories &&
          Array.isArray(businessCategories) &&
          businessCategories.length > 0
        ) {
          this.searchResults = businessCategories.map((businessCategory) => {
            return {
              text: businessCategory.displayName,
              value: businessCategory
            };
          });
        }
      } catch (error) {
        this.updateMessage({
          type: 'error',
          message: this.$t(
            'message.bizgainOnboarding.failedToFetchBusinessTypes'
          )
        });
      } finally {
        this.loadingBusinessCategories = false;
      }
    }, 300),
    updateBusinessType(category) {
      this.searchResults = [];
      let businessCategory = {
        text: category.displayName,
        value: category
      };
      this.searchResults.push(businessCategory);
      this.businessType = businessCategory;
      this.addServiceSuggestions(
        category.serviceTypes.map((x) => x.displayName)
      );
    },

    selectServiceFromSuggestion(suggestionService) {
      this.$refs.businessService.selectServiceFromSuggestion(suggestionService);
    },

    addServiceSuggestions(services) {
      this.serviceSuggestion = [];
      if (services && Array.isArray(services) && services.length > 0) {
        services.forEach((service) => this.serviceSuggestion.push(service));
      }
    },
    getSelectedServices() {
      // to remove the focus from v-autocomplete refer this :https://stackoverflow.com/a/58280593
      this.$refs.businessType.$refs.input.blur();
      this.isMenuActive = false;
      this.serviceSuggestion = [];
      let services =
        this.businessType &&
        this.businessType.value &&
        this.businessType.value.serviceTypes;
      if (services && Array.isArray(services) && services.length > 0) {
        this.addServiceSuggestions(services.map((x) => x.displayName));
      }
    },
    itemClick() {
      this.$refs.businessType.$refs.input.blur();
      this.isMenuActive = false;
    },
    async updateBusinessDetails() {
      try {
        this.isBusinessCategoriesUpdate = true;
        if (this.businessDetails) {
          this.newBusinessDetails = JSON.parse(
            JSON.stringify(this.businessDetails)
          );
          this.newBusinessDetails.category = this.businessType.value;
          if (this.newBusinessDetails.services) {
            this.newBusinessDetails.services = this.newServices;
          }
          await this.updateUserProperties({
            businessType: this.businessType.value.displayName
          });
          await this.redirect({ isAppFlow: true }, {}, false, launchState.BUSINESSDETAILSANIMATION, this.newBusinessDetails);
        }
      } catch {
        this.isBusinessCategoriesUpdate = false;
      }
    },
    discardChanges() {
      this.businessType = null;
      this.serviceSuggestion = [];
      this.newServices = [];
    },
    updateNewServices(newServices) {
      this.newServices = newServices;
    }
  },
  watch: {
    search(newValue) {
      if (!newValue) {
        this.enableNoDataText = false;
        // if the search text is removed then we disable no data message
        // The no data message is enabled in getCategories when the actual search starts
        return;
      }
      if (
        !this.businessType ||
        (typeof this.businessType == 'object' &&
          this.businessType.text != newValue)
      ) {
        this.getCategories(newValue);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep.business-type-services {
  .v-alert__icon {
    display: inline-flex !important;
  }
  .v-input__control {
    max-width: 420px;
  }

  span.v-chip.theme--light::after {
    background-color: white !important;
  }

  .v-select:not(.v-autocomplete) .v-select__slot input {
    visibility: hidden;
  }

  .v-autocomplete.v-select--is-menu-active .v-input__icon--append .v-icon {
    transform: none;
  }

  .v-text-field {
    .v-input__append-inner {
      cursor: pointer;
      .append-text {
        margin: auto;
        position: relative;
        top: -3px;
      }
    }
  }
  .v-input__icon--append .primary--text {
    color: black !important;
  }

  .v-chip {
    font-size: medium;
  }

  .suggestion:hover {
    cursor: pointer;
  }
  .suggestion:hover .v-chip__content {
    cursor: pointer;
  }
  .suggestion {
    background-color: white;
    border: 1px solid black;
  }
  .selected-suggestion {
    border-color: var(--v-primary-variation-1-base) !important;
    background-color: var(--v-primary-variation-1-base);
  }
  .service-suggestions {
    .v-chip {
      .v-chip__content {
        white-space: normal;
        height: auto;
      }
    }
  }
  .business-type-input {
    .v-text-field__details {
      display: none;
    }
    .v-input__control {
      min-height: auto;
    }
  }

  .business-type-selected .v-input__control .v-input__slot {
    background-color: var(--v-primary-variation-1-base);
    border-radius: 28px;
  }

  .business-type-suggestion {
    .v-chip {
      .v-chip__content {
        white-space: normal;
        height: auto;
      }
    }
    .selected-suggestion {
      .v-chip__content:hover {
        cursor: context-menu !important;
      }
    }
  }

  .suggestions {
    .layout {
      div {
        .v-chip {
          border: solid 0.5px var(--v-black-base);
        }
        .v-chip--disabled {
          border: solid 0.5px var(--v-primary-base);
        }
      }
    }
  }
}
::v-deep .add-service-txt-field {
  @media screen and (max-width: 320px) {
    .v-text-field__slot {
      width: 40px !important;
    }
  }
}
</style>
